import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {ButtonComponent} from './components/button/button.component';
import {ButtonBarComponent} from './components/button-bar/button-bar.component';
import {ButtonAnchorComponent} from './components/button-anchor/button-anchor.component';
import {RouterModule} from '@angular/router';
import {ButtonAnchorExternalComponent} from './components/button-anchor-external/button-anchor-external.component';
import {SharedModule} from '@shared/shared.module';


@NgModule({
  declarations: [ButtonComponent, ButtonBarComponent, ButtonAnchorComponent, ButtonAnchorExternalComponent],
  exports: [
    ButtonComponent,
    ButtonBarComponent,
    ButtonAnchorComponent,
    ButtonAnchorExternalComponent
  ],
  imports: [
    CommonModule,
    RouterModule,
    SharedModule,
  ]
})
export class ButtonsModule { }
